/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {InputDate, InputText} from '../../../../../../../../components/UI/Input'
import {InputTextWrapper} from '../../../../../../../../components/UI/Form/Input'
import {Select} from '../../../../../../../../components/UI/Select'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  LaundryConfigDaysFilter,
  MasiveReception,
  Reception,
  TypeClothe,
} from '../../../../../../model'
import {
  createReceptionLaundry,
  deleteReceptionByLaundry,
  getLaundryById,
  getLaundryConfigDays,
  getOrderReception,
  getPrintOrderReception,
  getReceptionByLaundry,
  getSendEmailReception,
} from '../../../../../../services'

import moment from 'moment'
import Swal from 'sweetalert2'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import {schemaOrderLaundryReception} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {ModalTicket} from '../../../../../componentes/Modal/ModalTicket'
import {ModalAddRecepcion} from '../modal/ModalAddRecepcion'
import {ModalWarningPoint} from '../modal/ModalWarningPoint'
const TableReception: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [showModalPrint, setShowModalPrint] = useState(false)
  const [showModalPoint, setShowModalPoint] = useState(false)

  const [showModalNew, setShowModalNew] = useState(false)
  const [showOption, setShowOption] = useState<boolean>(false)
  const [detailPrint, setDetailPrint] = useState<any>(null)
  const [idPermission, setIdPermission] = useState<any>('')
  const [idReception, setIdReception] = useState<any>(null)
  const [status, setStatus] = useState<any>(null)
  const [minLength, setMinLength] = useState<string>('')
  const [bolsaCorrelativo, setBolsaCorrelativo] = useState<string>('')
  const [rotuladoCorrelativo, setRotuladoCorrelativo] = useState<string>('')

  const [detailpermission, setDetailPermission] = useState<TypeClothe | any>(null)
  const methods = useForm<Reception>({
    resolver: yupResolver(schemaOrderLaundryReception),
  })
  const [typeFurniture, setTypeFurniture] = useState<Reception[] | any>([])
  const {
    control,
    setValue,
    handleSubmit,
    setError,
    register,
    watch,
    trigger,
    formState: {errors},
  } = methods
  const handleClear = () => {
    setIdPermission('')
  }
  const getOrderPrint = async () => {
    try {
      const response = await getOrderReception(currentTabItem.idToEdit)
      const data = response.data.data
      setDetailPrint(data)
      setBolsaCorrelativo(data.bolsaCorrelativo)
      setRotuladoCorrelativo(data.rotuladoCorrelativo)
      setShowModalPrint(true)
    } catch (error) {}
  }
  const getLaundryByIdListType = async () => {
    const response = await getLaundryById(currentTabItem.idToEdit)
    const data = response.data.data
    let addIdData = data.detalle?.map((item, index) => {
      return {idRopa: index + 1, ...item}
    })
    setData(addIdData)
    let countTotal =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.cantidad, 0) ||
      0
    let sumWeight =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.peso, 0) || 0
    setValue('pesoTotal', sumWeight)
    setValue('cantidadTotal', countTotal)
    setValue('bolsaCorrelativo', data.bolsaCorrelativo)
    setValue('rotuladoCorrelativo', data.rotuladoCorrelativo)
  }

  const getConfigDayList = async (filter: LaundryConfigDaysFilter) => {
    try {
      const response = await getLaundryConfigDays(filter, 1)
      if (response.data?.data?.length > 0) {
        return response.data.data[0]?.valor
      } else {
        return 0
      }
    } catch (error) {
      return 0
    }
  }

  const getLaundryByIdList = async () => {
    const response = await getLaundryById(currentTabItem.idToEdit)
    const data = response.data.data
    if (!data.puntoId) {
      setShowModalPoint(true)
    }

    let idResponsable = data?.huespedId
    let nombreResopnsable = data?.huesped
    trigger('responsable')
    setValue('puntoId', data.puntoId)
    setValue('responsableId', idResponsable)
    setValue('responsable', nombreResopnsable, {shouldValidate: true, shouldDirty: true})
    let lugarRecep = data.recepcion.lugarRecepcion ? data.recepcion.lugarRecepcion : ''
    setValue('lugarRecepcion', lugarRecep)
    setLoading(false)

    const dataConfigDays = await getConfigDayList({
      companiaId: data.companiaId,
      clienteId: data.clienteId,
      siteId: data.siteId,
      campamentoId: data.campamentoId,
      tipoServicioId: 'ROPA HUÉSPED',
      tipoHuespedId: data.tipoHuespedId,
    })
    const fechaLocal = data.recepcion.fechaRecepcion
      ? new Date(data.recepcion.fechaRecepcion)
      : null
    const formattedDate = fechaLocal
      ? fechaLocal.toISOString().slice(0, 10)
      : moment().format('YYYY-MM-DD')
    setValue('fechaRecepcion', formattedDate)
    const fechaLocalProgramada = data.recepcion.fechaProgramada
      ? new Date(data.recepcion.fechaProgramada)
      : null
    const formattedDateProgramada = fechaLocalProgramada
      ? fechaLocalProgramada.toISOString().slice(0, 10)
      : dataConfigDays
      ? moment().add(dataConfigDays, 'days').format('YYYY-MM-DD')
      : ''
    setMinLength(formattedDate)
    setValue('fechaProgramada', formattedDateProgramada)
    if (data.recepcion.detalle.length > 0) {
      setShowOption(false)
      setStatus(1)
      getReceptionByLaundryList(data.recepcion.id, data.bolsaCorrelativo, data.rotuladoCorrelativo)
      setIdReception(data.recepcion.id)
    } else {
      setShowOption(true)
      let addIdData = data.detalle?.map((item, index) => {
        return {idRopa: index + 1, ...item}
      })
      setData(addIdData)
      setStatus(0)
      let countTotal =
        data.detalle?.reduce(
          (acumulador: any, elemento: any) => acumulador + elemento.cantidad,
          0,
        ) || 0
      let sumWeight =
        data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.peso, 0) || 0
      setValue('pesoTotal', sumWeight)
      setValue('cantidadTotal', countTotal)
      setValue('bolsaCorrelativo', data.bolsaCorrelativo)
      setValue('rotuladoCorrelativo', data.rotuladoCorrelativo)
    }
  }
  const getReceptionByLaundryList = async (
    id: any,
    bolsaCorrelativo: string,
    rotuladoCorrelativo: string,
  ) => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getReceptionByLaundry(id, pagination.currentPage)
      if (!response.error) {
        let addIdData = response.data?.map((item, index) => {
          return {idRopa: index + 1, ...item}
        })
        setData(addIdData)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
        let countTotal =
          response.data?.reduce(
            (acumulador: any, elemento: any) => acumulador + elemento.cantidad,
            0,
          ) || 0
        let sumWeight =
          response.data?.reduce(
            (acumulador: any, elemento: any) => acumulador + elemento.peso,
            0,
          ) || 0

        setValue('pesoTotal', sumWeight)
        setValue('cantidadTotal', countTotal)
        setValue('bolsaCorrelativo', bolsaCorrelativo)
        setValue('rotuladoCorrelativo', rotuladoCorrelativo)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getReceptionPlaceList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'LugarEntrega',
      })
      const data = response.data.data || []
      const mappedMaster = data.map((master) => ({
        value: master.codigo.toString(),
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getLaundryByIdList()
    getReceptionPlaceList()
  }, [])

  const handleEdit = (item: TypeClothe) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }

  const columns: Column<TypeClothe>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Item' />,
      accessor: 'idRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de ropa' />,
      accessor: 'tipoRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
      accessor: 'peso',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'observaciones',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('RECEPCION/EDITAR')
            ? showOption && (
                <div
                  className='d-flex justify-content-center flex-shrink-0'
                  onClick={() => handleEdit(props.data[props.row.index])}
                >
                  <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                  </a>
                </div>
              )
            : null}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const {data: response} = await deleteReceptionByLaundry(selectedOn[0])
        if (!response.error) {
          ShowSnackBar('Se eliminó satisfactoriamente')
          getLaundryByIdList()
        } else {
          ShowSnackBar(response.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }
  const handleGetDateReception = (e: any) => {
    let value = e.target.value
    setMinLength(value)
    setError('fechaRecepcion', {})
  }
  const handleGetDateDate = (e: any) => {
    setError('fechaProgramada', {})
  }
  const onSubmitReception = async (dataInfo: Reception) => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Al finalizar la recepción no podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, finalizar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          setLoading(true)
          let obj = {
            detalle: data,
            id: idReception,
            ordenId: currentTabItem.idToEdit,
            lugarRecepcion: dataInfo.lugarRecepcion,
            responsable: dataInfo.responsable,
            responsableId: dataInfo.responsableId,
            fechaRecepcion: dataInfo.fechaRecepcion,
            fechaProgramada: dataInfo.fechaProgramada,
            cantidadTotal: dataInfo.cantidadTotal,
            pesoTotal: dataInfo.pesoTotal,
          }
          const {data: response} = await createReceptionLaundry(obj)
          if (!response.error) {
            ShowSnackBar('Se registró satisfactoriamente')
            getLaundryByIdList()
            getOrderPrint()
          } else {
            ShowSnackBar(response.message, 'error')
          }
          getLaundryByIdList()

          Swal.close()
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
    } catch (error) {}
  }
  const onSubmit = async (data: MasiveReception) => {
    try {
      getOrderPrint()
    } catch (error) {}
  }

  const downloadPDF = async () => {
    try {
      const response = await getPrintOrderReception(currentTabItem.idToEdit)
      const blob = new Blob([response.data], {type: 'application/pdf'})
      // Crea un enlace temporal y simula un clic para descargar el archivo
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Ticket masivo' // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }
  const sendEmail = async () => {
    try {
      const {data: response} = await getSendEmailReception(currentTabItem.idToEdit)
      if (!response.error) {
        ShowSnackBar('Se envío satisfactoriamente, revise su correo')
      } else {
        ShowSnackBar(response.message, 'error')
      }
    } catch (error) {}
  }

  const isEdit = currentTabItem.aditionalInformation?.order?.isView ? true : idReception
  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-2'>
          <FormProvider {...methods}>
            <form>
              {isAllowed('RECEPCION/FINALIZAR_RECEPCION') && (
                <div className='row'>
                  <div className='mb-2 col-3'>
                    <label className='required'>Lugar de recepción</label>
                    <Select
                      control={control}
                      name='lugarRecepcion'
                      data={typeFurniture}
                      errors={errors}
                      disabled={isEdit}
                    />
                  </div>
                  <div className='mb-2 col-3'>
                    <InputTextWrapper
                      labelText='Huésped(recepción)'
                      name='responsable'
                      readOnly
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Fecha de recepción:</label>
                    <InputDate
                      name='fechaRecepcion'
                      register={register}
                      errors={errors}
                      onChange={handleGetDateReception}
                      disabled={isEdit}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Fecha Programada de Devolución al Huésped:</label>
                    <InputDate
                      name='fechaProgramada'
                      register={register}
                      errors={errors}
                      minValue={minLength}
                      onChange={handleGetDateDate}
                      disabled={isEdit}
                    />
                  </div>
                </div>
              )}
              <div className='row'>
                <div className='col-sm-12 col-lg-2'>
                  <label>Cantidad total:</label>
                  <InputText
                    name='cantidadTotal'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-2'>
                  <label>Peso total:</label>
                  <InputText name='pesoTotal' register={register} errors={errors} disabled={true} />
                </div>
                <div className='col-sm-12 col-lg-2'>
                  <label>Codigo de Bolsa:</label>
                  <InputText
                    name='bolsaCorrelativo'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-2'>
                  <label>Rotulado:</label>
                  <InputText
                    name='rotuladoCorrelativo'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
              </div>
              {currentTabItem.aditionalInformation?.order?.isView ? null : status === 0 ? (
                <div className='col-sm-12 col-lg-12 d-flex justify-content-end align-items-end'>
                  <div className='d-flex justify-content-end'>
                    {isAllowed('RECEPCION/FINALIZAR_RECEPCION') && (
                      <button
                        type='button'
                        className='btn btn-primary me-3'
                        disabled={data.length < 1}
                        onClick={handleSubmit(onSubmitReception)}
                      >
                        Finalizar Recepción
                      </button>
                    )}
                    {isAllowed('RECEPCION/AGREGAR') && (
                      <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                        Agregar
                      </button>
                    )}
                    {isAllowed('RECEPCION/ELIMINAR') && (
                      <button
                        type='button'
                        className='btn btn-primary me-3'
                        disabled={selectedOn.length < 1}
                        onClick={handleDelete}
                      >
                        Eliminar
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className='col-sm-12 col-lg-12 d-flex justify-content-end align-items-end'>
                  <div className='d-flex justify-content-end'>
                    {isAllowed('RECEPCION/REIMPRIMIR') && (
                      <button
                        type='button'
                        className='btn btn-success me-3'
                        onClick={handleSubmit(onSubmit)}
                      >
                        Re-imprimir
                      </button>
                    )}
                  </div>
                </div>
              )}
            </form>
          </FormProvider>
        </div>
        {isAllowed('RECEPCION/LISTAR') && (
          <>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
        <ModalAddRecepcion
          show={showModalNew}
          setShow={setShowModalNew}
          getReceptionByLaundryList={getLaundryByIdListType}
          detailpermission={detailpermission}
          idPermission={idPermission}
          setIdPermissionList={handleClear}
        />
        <ModalTicket
          show={showModalPrint}
          setShow={setShowModalPrint}
          idPermission={''}
          nameTitle={'recepción'}
          userTicket={'huesped'}
          data={detailPrint}
          typeTab={'reception'}
          funcSeePDF={downloadPDF}
          funcSendEmail={sendEmail}
        />
        <ModalWarningPoint show={showModalPoint} setShow={setShowModalPoint} />
      </KTCard>
    </>
  )
}

const TableReceptionWrapper = () => {
  return (
    <KTableProvider>
      <TableReception />
    </KTableProvider>
  )
}
export {TableReceptionWrapper}
